module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('section', {
    staticClass: "content-header"
  }, [_vm._m(0), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Remessa',
        href: '#'
      }, {
        text: 'Lista de Remessas',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "listaRemessas"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('numeroProjeto')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("Numero do Projeto:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formIntervencao.numeroProjeto),
      expression: "formIntervencao.numeroProjeto"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:3'),
      expression: "'required|min:3'"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "numeroProjeto",
      "type": "text"
    },
    domProps: {
      "value": (_vm.formIntervencao.numeroProjeto)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formIntervencao, "numeroProjeto", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('conta corrente')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('numeroProjeto')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('intervencao_bndes')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("Numero da Intervenção")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formIntervencao.intervencao_bndes),
      expression: "formIntervencao.intervencao_bndes"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:3'),
      expression: "'required|min:3'"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "intervencao_bndes",
      "type": "text"
    },
    domProps: {
      "value": (_vm.formIntervencao.intervencao_bndes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formIntervencao, "intervencao_bndes", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('conta corrente')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('intervencao_bndes')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('g-button-moema', {
    attrs: {
      "color": "primary",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.salvar($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Salvar\n                    ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.busca),
      expression: "busca"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa (ID BNDES, nota, CNPJ, projeto, status)..."
    },
    domProps: {
      "value": (_vm.busca)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.busca = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "disabled": !_vm.busca,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.busca = ''
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    ref: "tabelaRemessas",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "bordered": _vm.table.bordered,
      "items": _vm.provedorRemessas,
      "fields": _vm.table.fields,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "cnpj",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("cnpj")(row.value)))]
      }
    }, {
      key: "data_envio",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.value, 'DD/MM/YYYYm')))]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('b-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.table.totalRows > _vm.table.perPage),
      expression: "table.totalRows > table.perPage"
    }],
    staticClass: "my-3",
    attrs: {
      "total-rows": _vm.table.totalRows,
      "per-page": _vm.table.perPage,
      "align": "center"
    },
    model: {
      value: (_vm.table.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.table, "currentPage", $$v)
      },
      expression: "table.currentPage"
    }
  })], 1)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('span', [_vm._v("Remessas")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c0008598!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/remessas/ListaRemessaBNDES.vue
// module id = 2077
// module chunks = 1